import { Form } from 'antd';
import React, { FC, useMemo, } from 'react';

import { JCMSCTA } from '../../JCMSCTA';
import { TRANSLATION_CODES } from '../constants';
import { JFieldDTO } from '../models/overrideBE';
import { useCompositorContext } from './CompositorProvider';

export interface FormListProps {
    name: (string | number)[],
    field: JFieldDTO,
    children: (field: JFieldDTO, name: (string | number)[], listname: (string | number)[]) => any
}
export const FormList: FC<FormListProps> = ({ field, ...props }) => {
    const { translate } = useCompositorContext()
    function getDefaultValue(field: JFieldDTO) {

        if (field.children?.length) {
            const obj: Record<string, any> = {}

            return [obj]
        }
        return [undefined]
    }
    function getListInitValue(field: JFieldDTO) {
        const values: any[] = []
        if (field.children?.length) {
            for (const child of field.children) {
                if (child.values?.length) {
                    for (let i = 0; i < child.values.length; i++) {
                        const childValue = child.values[i];
                        if (childValue?.length) {
                            if (!values[i]) values[i] = {}
                            values[i][child.hurlId] = childValue
                        }
                    }
                }
            }
        } else {
            if (field.values?.length) {
                for (const v of field.values) {
                    values.push(v)
                }
            }
        }
        return values.length ? values : getDefaultValue(field)
    }

    const maxRepeat = useMemo(() => field.cmsConfig.componentConfig?.maxCount || 99999, [field])

    const addCTALabel = useMemo(() => translate(TRANSLATION_CODES.ADD), [])
    const removeCTALabel = useMemo(() => translate(TRANSLATION_CODES.REMOVE), [])

    return (

        <Form.List name={props.name} initialValue={getListInitValue(field)}>
            {
                (_fields, { add, remove }) => {
                    return (
                        <div className='field-list'>
                            {
                                _fields.map((value, i) => {
                                    const _field: JFieldDTO = JSON.parse(JSON.stringify(field))
                                    if (_field.children?.length) {
                                        for (const child of _field.children) {
                                            if (child.values?.length && child.values[value.key]) {
                                                child.values = [child.values[value.key]]
                                            } else {
                                                child.values = []
                                            }
                                        }
                                    } else {
                                        if (!!_field.values?.length && _field.values[value.key]) {
                                            _field.values = [_field.values[value.key]]
                                        } else {
                                            _field.values = []
                                        }
                                    }
                                    return (
                                        <div className={`field-list-item field-list-item-${value.name}`} key={value.name}>
                                            {props.children(_field, [value.name], [...props.name, value.name])}
                                            {
                                                i > 0 && (
                                                    <JCMSCTA
                                                        title={removeCTALabel}
                                                        type="BUTTON"
                                                        color='default'
                                                        size='small'
                                                        action={() => remove(value.name)}
                                                    />
                                                )
                                            }
                                        </div>
                                    )
                                })
                            }
                            {
                                _fields.length < maxRepeat && (

                                    <JCMSCTA
                                        title={addCTALabel}
                                        type="BUTTON"
                                        size='small'
                                        action={() => add()}
                                    />
                                )
                            }
                        </div>
                    )
                }
            }
        </Form.List>

    )
}